import { render, staticRenderFns } from "./commandeclient_view.vue?vue&type=template&id=104854b9&scoped=true&"
import script from "./commandeclient_view.vue?vue&type=script&lang=js&"
export * from "./commandeclient_view.vue?vue&type=script&lang=js&"
import style0 from "./commandeclient_view.vue?vue&type=style&index=0&id=104854b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104854b9",
  null
  
)

export default component.exports